import {ProductFilterConditionRestDto, ProductFilterRestDto} from "@/api/pharma-cpc-mgmt/models";
import {DpException} from "@/exception/DpException";
import {ProductFilterConditionTypeEnum} from "@/models/enum/ProductFilterConditionTypeEnum";

/*
* Determines the type of filter condition
*
* Receives a ProductFilterConditionRestDto
* Returns a string value that is either: "all", "cnk-list" or "brands-categories"
*/
function determineProductFilterConditionType(filterCondition: ProductFilterConditionRestDto): ProductFilterConditionTypeEnum {
    if (filterCondition.include_all_products !== undefined && filterCondition.include_all_products) {
        return ProductFilterConditionTypeEnum.ALL;
    } else if (filterCondition.cnk_codes_included !== undefined) {
        return ProductFilterConditionTypeEnum.CNK_LIST;
    } else if (filterCondition.product_codes_included !== undefined) {
        return ProductFilterConditionTypeEnum.PRODUCT_CODE_LIST;
    } else if (filterCondition.product_trademark_filters !== undefined) {
        return ProductFilterConditionTypeEnum.TRADEMARKS_CATEGORIES;
    } else if (filterCondition.product_brand_filters !== undefined || filterCondition.product_category_filters !== undefined) {
        return ProductFilterConditionTypeEnum.BRANDS_CATEGORIES;
    } else {
        //TODO ask proper validation
        throw [new DpException('Filter condition is built incorrectly')];
    }
}

function determineProductFilterConditionTypes(filter: ProductFilterRestDto): ProductFilterConditionTypeEnum[] {
    return filter.filter_conditions.map(determineProductFilterConditionType);
}


export {determineProductFilterConditionType, determineProductFilterConditionTypes};
